<script lang="ts">
  /** One of the interface's icons (see icons.ts). Sized to the text by default; always decorative. */
  import { ICONS, type IconName } from '../icons';

  let { name, size = '1.15em' }: { name: IconName; size?: string | number } = $props();
  const icon = $derived<{ stroke?: string; fill?: string }>(ICONS[name]);
</script>

<svg
  class="icon"
  width={size}
  height={size}
  viewBox="0 0 24 24"
  aria-hidden="true"
  focusable="false"
  data-icon={name}
>
  {#if icon.stroke}<path
      d={icon.stroke}
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />{/if}
  {#if icon.fill}<path d={icon.fill} fill="currentColor" />{/if}
</svg>

<style>
  .icon {
    display: inline-block;
    flex: none;
    vertical-align: -0.2em;
  }
</style>
